import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { checkUserFranchiseeStatus } from '../services/signupService';
import { getUserInfo } from '../services/userService';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [hasCompleteAccount, setHasCompleteAccount] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        try {
          // First check if user account is suspended by calling getUserInfo
          const userInfo = await getUserInfo(await currentUser.getIdToken());

          // Check if user has complete franchisee account
          const statusResult = await checkUserFranchiseeStatus(currentUser.uid);
          setHasCompleteAccount(statusResult.hasCompleteAccount);

          if (!statusResult.hasCompleteAccount) {
            console.log('User has incomplete account, will redirect to login');
            // Sign out user with incomplete account
            await auth.signOut();
            setUser(null);
            setHasCompleteAccount(false);
          }
        } catch (error) {
          console.error('Error checking user status in ProtectedRoute:', error);

          // Check if this is a suspended account error
          if (error.message && error.message.includes('suspended')) {
            console.log('Suspended account detected in ProtectedRoute, signing out');
          }

          // On error (including suspended accounts), sign out user for safety
          await auth.signOut();
          setUser(null);
          setHasCompleteAccount(false);
        }
      } else {
        setHasCompleteAccount(false);
      }

      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    // Return a loading spinner
    return (
      <div className="min-h-screen bg-sky-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (user && hasCompleteAccount) ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
